import React, { useState } from 'react'
import { __ } from '@wordpress/i18n';
import axios from 'axios';

let controller = new AbortController();

const Wb_live_preview = (props) => {

    const [Preview_detail, setPreview_detail] = useState({ loader: false, url: '' });

    var img_path = wdkitData.WDKIT_URL,
        loader_logo = wdkitData?.wdkit_white_label?.plugin_logo || img_path + "assets/images/jpg/wdkit_loader.gif";

    const IFrame_load = (e) => {

        if (Preview_detail?.loader) {
            setPreview_detail({ ...Preview_detail, loader: false });
        }

        let iframe = document.querySelector('.wkit-widget-iframe').contentWindow.document;

        if ('elementor' === props?.widget_data?.type) {
            let ele_btn = iframe.querySelectorAll('.eui-1jjohtx-MuiButtonBase-root-MuiToggleButton-root');
            ele_btn?.forEach(btn => {
                btn.disabled = true;
            });
        }
    }

    const Live_preview_load = () => {
        let p_data = { ...Preview_detail, loader: true },
            save_btn = document.querySelector('.wkit-widget-edit-setting-panel').querySelector('.wkit-wb-publish-btn ');

        setPreview_detail(p_data);
        if (!save_btn.classList.contains('wdkit-saved') || !save_btn.classList.contains('wdkit-disable')) {
            save_btn.click();
        }

        let preview_data = {
            widget_name: props?.widget_data?.name || false,
            widget_id: props?.widget_data?.widget_id || false,
            widget_type: props?.widget_data?.type || false,
            page_data: 'wb-' + (props?.widget_data?.widget_id) || false,
        };

        controller = new AbortController();

        let form = new FormData();
        form.append('action', 'get_wdesignkit');
        form.append('kit_nonce', wdkitData.kit_nonce);
        form.append('type', 'wkit_widget_preview');
        form.append('widget_data', JSON.stringify(preview_data));

        axios.post(ajaxurl, form, { signal: controller.signal }).then((response) => {

            if (response.data.success) {
                setPreview_detail({ ...p_data, url: response.data.preview_url });
                p_data = { ...p_data, url: response.data.preview_url };

                if (response.data.preview_url && 'elementor' === props?.widget_data?.type) {
                    let ele_loading = setInterval(() => {
                        let iframe = document.querySelector('.wkit-widget-iframe')?.contentWindow?.document;
                        if (iframe.querySelector('#elementor-loading')) {
                            setPreview_detail({ ...p_data, loader: false });
                            clearInterval(ele_loading);
                        }
                    }, 100);
                }
            } else {
                setPreview_detail({ ...p_data, loader: false });
            }
        })

    }

    const Close_preview = (e) => {

        if (!e.target.closest('.wkit-wb-live-preview') || e.target.closest('.wkit-popup-close-icon')) {
            if (controller) {
                controller.abort();
            }

            setPreview_detail({ loader: false, url: '' });
        }
    }

    const Preview_check = (type) => {
        const isPluginActive = Object.values(props.plugin_status)[0] === 'active';
        const isDraft = props?.widget_data?.publish_type === 'Draft';

        if (type === 'tooltip') {
            if (!isPluginActive && isDraft) {
                return __('To use live preview, install the required plugin and publish the widget.', 'wdesignkit');
            } else if (!isPluginActive) {
                return __('Live preview requires the relevant plugin. Please install it first.', 'wdesignkit');
            } else if (isDraft) {
                return __('Live preview is unavailable for draft widgets. Publish the widget to enable live preview.', 'wdesignkit');
            }
            return '';
        }
        if (type === 'btn') {
            return !isPluginActive || isDraft;
        }
    };

    return (
        <>
            <div className='wkit-preview-btn-container'>
                {Preview_check('btn') &&
                    <span className='wkit-live-preview-tooltip'>{Preview_check('tooltip')}</span>
                }
                <button className={`wkit-live-preview-btn ${Preview_check('btn') ? 'wdkit-disable-preview' : ''}`} onClick={() => { Live_preview_load() }}>{__('Live Preview', 'wdesignkit')}</button>
            </div>
            {(Preview_detail.url || Preview_detail.loader) && 'bricks' !== props?.widget_data?.type &&
                <div id="wkit-wb-popup-open" className="wkit-overlay wkit-wb-preview-popup" onClick={(e) => { Close_preview(e) }}>
                    <div className='wkit-wb-live-preview'>
                        <div className="wkit-popup-close-icon" onClick={(e) => { Close_preview(e) }}>
                            <svg width="13" height="13" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.40091 15.2558C1.66182 15.5169 2.01481 15.6637 2.38274 15.6637C2.75067 15.6637 3.10366 15.5169 3.36456 15.2558L8.29499 10.2193L13.2254 15.2558C13.5884 15.6217 14.118 15.7645 14.6141 15.6306C15.1103 15.4967 15.4981 15.1062 15.6309 14.6064C15.7639 14.1067 15.6221 13.5733 15.2588 13.2076L10.2587 8.24141L15.2588 3.27521C15.5659 2.91424 15.6703 2.42082 15.5365 1.96497C15.4027 1.50913 15.0485 1.15236 14.5959 1.01757C14.1431 0.882762 13.6535 0.987976 13.2949 1.29727L8.29499 6.26348L3.36455 1.29727C3.00619 0.987976 2.51632 0.882762 2.06375 1.01757C1.61119 1.15237 1.257 1.50911 1.12317 1.96497C0.989339 2.42082 1.0938 2.91424 1.40087 3.27521L6.3313 8.24141L1.40087 13.2076C1.11968 13.4728 0.959961 13.8436 0.959961 14.2316C0.959961 14.6198 1.11968 14.9904 1.40087 15.2557L1.40091 15.2558Z" fill="black" />
                            </svg>
                        </div>
                        {Preview_detail.loader &&
                            <div className='wkit-loader-container'>
                                <img className='wkit-loader-logo' src={loader_logo} alt={__('WDesignKit Logo', 'wdesignkit')} />
                            </div>}

                        {Preview_detail.url &&
                            <iframe className='wkit-widget-iframe' referrerPolicy="no-referrer" src={Preview_detail.url} onLoad={(e) => { IFrame_load(e) }} />
                        }
                    </div>
                </div>
            }
        </>
    )
}

export default Wb_live_preview;